import { configureStore } from "@reduxjs/toolkit";

import initReducer from "../store/init/initSlice";
import requestsReducer from "./requests/requestsSlice";
import UterumReducer from "../store/Uterum/UterumSlice";
import OptionsReducer from "../store/Options/OptionsSlice";
import ImagesReducer from "../store/Images/ImagesSlice";
import ResultReducer from "../store/Result/ResultSlice";

/*
NOTE:
- Lowercase is used for internal application data
- Upper camelcase is used for everything from backend APIs
*/

const store = configureStore({
  reducer: {
    init: initReducer,
    requests: requestsReducer,
    Uterum: UterumReducer,
    Options: OptionsReducer,
    Images: ImagesReducer,
    Result: ResultReducer,
  },
});

export default store;
